module.exports = __webpack_public_path__ + "img/odyssey.363c789c.jpeg";